<template>
    <div class="educationExperience">
        <div class="main">
            <p class="title">教育经历<span class="sign">必填</span> <span class="add"
                      @click="interactive('ruleForm')">
                    <i class="el-icon-plus"></i>添加
                </span></p>
            <div class="mould"
                 v-for="(item,index) in educateList"
                 :key="index">
                <p>{{item.universityIdFeedback}}<span>{{item.graduationStart|formatDate}}-{{item.graduationEnd|formatDate}}
                        <el-button v-show="buttomshow"
                                   style="margin-left:20px;"
                                   type="text"
                                   @click="edit(index)">编辑</el-button>
                        <el-button v-show="buttomshow"
                                   type="text"
                                   @click="open(index)">删除</el-button>
                        <el-button v-show="!buttomshow"
                                   style="margin-left:20px;"
                                   type="text"
                                   @click="editthis(item.id,index)">编辑该项</el-button>
                        <el-button v-show="!buttomshow"
                                   type="text"
                                   @click="openthis(item.id)">删除该项</el-button>
                    </span></p>
                <p class="entry">{{item.educationFeedback}}/{{item.majorIdFeedback}}</p>
            </div>
            <el-form v-show="showed"
                     :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     :inline="true"
                     label-position="top"
                     label-width="100px"
                     class="demo-ruleForm">
                <h3>编辑教育经历:</h3>
                <el-form-item label="学校名称"
                              prop="universityId">
                    <el-select v-model="ruleForm.universityId"
                               filterable
                               placeholder="请选择学校名称">
                        <el-option v-for="(item,index) in schoollist"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学历"
                              prop="education">
                    <el-select v-model="ruleForm.education"
                               placeholder="请选择学历">
                        <el-option v-for="(item,index) in highEducationlist"
                                   :key="index"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="专业名称"
                              prop="majorId">
                    <el-select v-model="ruleForm.majorId"
                               filterable
                               placeholder="请选择专业名称">
                        <el-option v-for="(item,index) in majorlist"
                                   :key="index"
                                   :label="item.majorName"
                                   :value="item.majorId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="在校时间"
                              prop="graduationStart">
                    <el-date-picker v-model="ruleForm.graduationStart"
                                    type="date"
                                    @change="changeendstartDate"
                                    placeholder="开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=" "
                              prop="graduationEnd">
                    <el-date-picker style="margin-left:10px;"
                                    v-model="ruleForm.graduationEnd"
                                    @change="changeendDate"
                                    type="date"
                                    placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-col v-show="buttomshow"
                        style="margin-top:30px">
                    <el-form-item class="center">
                        <el-button type="primary"
                                   @click="subit('ruleForm')">保存</el-button>
                        <el-button @click="rest('ruleForm')">取消</el-button>
                    </el-form-item>
                </el-col>
                <el-col v-show="!buttomshow"
                        style="margin-top:30px">
                    <el-form-item class="center">
                        <el-button type="primary"
                                   @click="subitsaveeducateexperience('ruleForm')">确认</el-button>
                        <el-button @click="restsaveeducateexperience('ruleForm')">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    selecteducationtype,
    selectschool,
    selectmajor,
    selectdictbyvalue,
    selectmajorbyid,
    selectschoolbyid
} from "@/api/homePage";
import {
    saveeducateexperience,
    selecteducateexperience,
    delecteducateexperience
} from "@/api/apiall";
export default {
    data() {
        return {
            buttomshow: false,
            // showedbitian: true,
            number: 999,
            // type: "",
            majorlist: [],
            highEducationlist: [],
            schoollist: [],
            educateList: [],
            showed: false,
            ruleForm: {
                id: "",
                personId: "",
                universityId: "",
                education: "",
                majorId: "",
                graduationStart: "",
                graduationEnd: "",
                educationFeedback: "",
                universityIdFeedback: "",
                majorIdFeedback: ""
            },
            rules: {
                universityId: [
                    {
                        required: true,
                        message: "请输入学校名称",
                        trigger: "change"
                    }
                ],
                education: [
                    {
                        required: true,
                        message: "请输入学历",
                        trigger: "change"
                    }
                ],
                majorId: [
                    {
                        required: true,
                        message: "请输入专业名称",
                        trigger: "change"
                    }
                ],
                graduationStart: [
                    {
                        required: true,
                        message: "请输入开始时间",
                        trigger: "change"
                    }
                ],
                graduationEnd: [
                    {
                        required: true,
                        message: "请输入结束时间",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            if (to.path == "/Curriculumvitae") {
                this.buttomshow = false;
            } else {
                this.buttomshow = true;
            }
        }
    },
    created() {
        if (this.$route.path == "/Curriculumvitae") {
            this.buttomshow = false;
        } else {
            this.buttomshow = true;
        }
        this.search();
        this.searchschool();
        this.searchajor();
        // if (
        //     sessionStorage.getItem("userId") != null ||
        //     sessionStorage.getItem("userId") != undefined
        // ) {
        //     this.searchselecteducateexperience();
        // }
    },
    methods: {
        searchselecteducateexperience() {
            this.ruleForm.personId = sessionStorage.getItem("informationId");
            selecteducateexperience({ personId: this.ruleForm.personId }).then(
                res => {
                    if (res.status === 2000) {
                        this.educateList = res.data;
                    }
                }
            );
        },
        changeendstartDate() {
            if (this.ruleForm.graduationStart > this.ruleForm.graduationEnd) {
                this.ruleForm.graduationEnd = "";
            }
        },
        changeendDate() {
            if (this.ruleForm.graduationStart > this.ruleForm.graduationEnd) {
                this.ruleForm.graduationEnd = "";
                this.$message({
                    type: "warning",
                    message: "结束时间必须大于开始时间!"
                });
            }
        },
        edit(index) {
            this.showed = true;
            this.number = index;
            this.ruleForm = { ...this.educateList[index] };
            // this.educateList.splice(index, 1);
        },
        editthis(item, index) {
            this.showed = true;
            this.number = index;
            this.ruleForm = { ...this.educateList[index] };
        },
        open(index) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning"
            }).then(() => {
                this.del(index);
                this.$message({
                    type: "success",
                    message: "删除成功!"
                });
            });
        },
        openthis(item) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                delecteducateexperience({ id: item }).then(res => {
                    if (res.status === 2000) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.searchselecteducateexperience();
                    }
                });
            });
        },
        del(index) {
            this.educateList.splice(index, 1);
        },
        searchschool() {
            selectschool().then(res => {
                if (res.status === 2000) {
                    this.schoollist = res.data;
                }
            });
        },
        subitsaveeducateexperience(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.ruleForm.personId = sessionStorage.getItem(
                        "informationId"
                    );
                    saveeducateexperience(this.ruleForm).then(res => {
                        if (res.status === 2000) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.ruleForm = {};
                            this.$refs[formName].clearValidate();
                            this.showed = false;
                            this.searchselecteducateexperience();
                        } else {
                            this.$message({
                                message: res.data,
                                type: "warning"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        restsaveeducateexperience(formName) {
            this.$refs[formName].resetFields();
            this.showed = false;
        },
        searchajor() {
            selectmajor().then(res => {
                if (res.status === 2000) {
                    this.majorlist = res.data;
                }
            });
        },
        search() {
            selecteducationtype().then(res => {
                if (res.status === 2000) {
                    this.highEducationlist = res.data;
                }
            });
        },
        interactive(formName) {
            this.number = 999;
            this.ruleForm.id = "";
            if (this.educateList.length < 10) {
                this.showed = true;
                this.$refs[formName].clearValidate();
            } else {
                this.$message({
                    message: "最多添加10条",
                    type: "warning"
                });
            }
        },
        subit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    return new Promise(async resolve => {
                        await selectdictbyvalue({
                            type: "education",
                            value: this.ruleForm.education
                        }).then(res => {
                            if (res.status === 2000) {
                                this.ruleForm.educationFeedback =
                                    res.data.label;
                            }
                        });
                        await selectmajorbyid(this.ruleForm.majorId).then(
                            res => {
                                if (res.status === 2000) {
                                    this.ruleForm.majorIdFeedback =
                                        res.data.majorName;
                                }
                            }
                        );
                        await selectschoolbyid(this.ruleForm.universityId).then(
                            res => {
                                if (res.status === 2000) {
                                    this.ruleForm.universityIdFeedback =
                                        res.data.name;
                                }
                            }
                        );
                        if (this.number != 999) {
                            this.educateList[this.number] = this.ruleForm;
                        } else {
                            this.educateList.push(this.ruleForm);
                        }
                        this.ruleForm = {};
                        this.$refs[formName].clearValidate();
                        this.showed = false;
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // showedchange() {
        //     this.showedbitian = false;
        // },
        // showedchangedisplay() {
        //     this.showedbitian = true;
        // },
        rest(formName) {
            // this.$refs[formName].resetFields();
            this.ruleForm = {};
            this.showed = false;
        },
        save(formName) {
            this.$emit("educationExperienceValue", this.educateList);
        }
    }
};
</script>


<style scoped lang="scss">
.educationExperience {
    width: 900px;
    background-color: #fff;
    float: left;
    .mould {
        // border: 1px #f5f6f7 solid;
        p {
            position: relative;
            margin-top: 20px;
            font-size: 15px;
            span {
                position: absolute;
                right: 0;
                float: right;
                color: #666;
            }
        }
        .entry {
            font-size: 14px;
            color: #666;
        }
    }
    .main {
        padding: 30px;
        border-bottom: 1px solid #ddd;
        .title {
            font-size: 18px;
            color: #333;
            .add {
                cursor: pointer;
                float: right;
                color: #fabe00;
                font-size: 15px;
            }
        }
        .sign {
            display: inline-block;
            margin-left: 12px;
            position: relative;
            top: -2px;
            width: 37px;
            height: 18px;
            color: #fff;
            background-color: #fabe00;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            border-radius: 4px;
        }
        .el-form {
            margin-top: 20px;
            margin-bottom: 60px;
            .el-input,
            .el-select {
                width: 230px;
            }
            h3 {
                font-size: 17px;
                margin: 20px 0;
                font-weight: 500;
            }
            .center {
                position: relative;
                left: 50%;
                transform: translateX(-50%);
            }
            /deep/ .el-form-item {
                margin-bottom: 6px !important;
                .el-form-item__label {
                    padding: 0 !important;
                }
            }
        }
        .el-form--label-top .el-form-item__label {
            padding: 0;
        }
        .el-form--inline .el-form-item {
            margin-right: 30px;
        }
    }
}
</style>
